import Cookies from "js-cookie";

/** Clear session and return to login when the access token is missing or rejected. */
export function handleAuthFailure(response) {
  if (response.status === 401 || response.status === 403) {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    Cookies.remove("user_name");
    Cookies.remove("user_email");
    Cookies.remove("user_role");
    window.location.href = "/";
    return true;
  }
  return false;
}

export function getAccessToken() {
  return Cookies.get("access_token");
}
